import {Component, Input, OnInit} from '@angular/core';
import {GroupIntermediateExam} from "../../../../types/interfaces";
import {PreloaderService} from "../../../../services/preloader/preloader.service";
import {StudentService} from "../../../../services/mygreencountry/student.service";
import {MyGreenCountry} from "../../../../services/mygreencountry/my-greencountry";
import {EnglishLevelApiResponse, StudentExamAnswerApiResponse} from "../../../../types/apiResponse.interface";

@Component({
    selector: 'app-lesson-test',
    templateUrl: './test.component.html',
    styleUrls: ['./test.component.scss'],
})
export class TestComponent implements OnInit {

    @Input() exam: GroupIntermediateExam;
    @Input() withMarginBottom: boolean = false;
    @Input() noMarginBottom: boolean = false;
    @Input() isEnglishLevel: boolean = false;
    @Input() try:number|undefined= undefined;
    tryInfo :string|undefined = undefined;

    constructor(private preloaderService: PreloaderService,
                private studentService: StudentService,
                private GCService: MyGreenCountry,) {
    }

    ngOnInit() {
        if (this.try){
            this.tryInfo = this.try == 1? `attempt` : `attempts`;
        }
    }

    async goToTest(uuid: string) {
        await this.preloaderService.showLoading("Зачекайте, будь ласка ");

        this.studentService.getExamUrl(uuid)
            .subscribe({
                next: (response:StudentExamAnswerApiResponse) => {
                    if (response.url){
                        this.GCService.openUrl(response.url)
                    }
                },

                error: (error) => {
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                }

            })

    }

    getEnglishLevelExamUrl() {
        this.preloaderService.showLoading('Зачекайте, будь ласка');

        this.studentService.getEnglishLevelTestUrl()

            .subscribe({

                next: (response:EnglishLevelApiResponse) => {

                    if (response.url){
                        this.GCService.openUrl(response.url)
                    }

                },

                error: (error) => {

                    //@TODO: show error message
                    console.log('error', error)

                },

                complete: () => {
                    this.preloaderService.hideLoading();
                }
            })


    }

}
